<template>
  <v-dialog
    :value="visiblePopup"
    :max-width="330"
    @click:outside="onNoClickButton"
    @keydown.esc="onNoClickButton"
  >
    <v-card class="popup-wrapper">
      <div class='title-section'>
        <div class='warning-icon'>
          <img :src='warningIcon'>
        </div>
        <div class="title">{{$t(title)}}</div>
      </div>
      <div class='message-section'>
        <span class="message">{{$t(message)}}</span>
      </div>
      <div class="buttons">
        <v-btn small depressed class="no-button btn-secondary" @click="onNoClickButton()" v-if="showCancelButton">
          {{$t("confirm.cancel")}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :loading='deleteUserLoading'>
          {{$t("confirm.ok")}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import warningIcon from '@/assets/icons/warning_icn@1x.svg';
import { mapGetters } from 'vuex';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'DeleteUserPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    message: String,
    showCancelButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['deleteUserLoading']),
    warningIcon() {
      return warningIcon;
    },
  },
  watch: {
    deleteUserLoading() {
      if (!this.deleteUserLoading) {
        this.onNoClickButton();
      }
    },
  },
  methods: {
    async onYesClickButton() {
      this.$emit('clicked', true);
    },
    onNoClickButton() {
      this.$emit('clicked', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(380);
  padding: $space-8 $space-10;
  .title-section {
    display: flex;
    .title {
      color: var(--text-primary);
      font-size: $font-size-base;
      font-weight: 600;
      letter-spacing: 1.12px;
      line-height: $space-4;
      text-transform: uppercase;
      padding-bottom: rem(23);
      margin-left: rem(7);
      margin-top: $space-0-5;
    }
  }
  .message {
    font-size: $font-size-base;
    line-height: 1.36;
    font-weight: normal;
    color: var(--text-primary);
    white-space: pre-line;
    letter-spacing: 0;
    line-height: rem(18);
  }

  .buttons {
    text-align: right;
    padding-top: rem(30);

    .no-button {
      height: $space-8;
      border-radius: $radius-sm;
    }

    .yes-button {
      height: $space-8;
      border-radius: $radius-sm;
      margin-left: $space-2;
    }
  }
}
</style>
